var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6 5.2H0V23.4C0 24.83 1.17 26 2.6 26H20.8V23.4H2.6V5.2ZM23.4 0H7.8C6.37 0 5.2 1.17 5.2 2.6V18.2C5.2 19.63 6.37 20.8 7.8 20.8H23.4C24.83 20.8 26 19.63 26 18.2V2.6C26 1.17 24.83 0 23.4 0ZM19.5 2.6V9.1L18.2 8.125L16.9 9.1V2.6H19.5ZM23.4 18.2H7.8V2.6H14.3V14.3L18.2 11.375L22.1 14.3V2.6H23.4V18.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.64468282737edfad6a4ce58242962f63.svg";
export { ForwardRef as ReactComponent };